import './styles/App.scss';
import Home from './Home';
import './initializations';

import { RecoilRoot } from 'recoil';
import { AppContextProvider } from './AppContext';
import { ChatContextProvider } from './context/ChatContext';

import ModalBox from './components/ModalBox/ModalBox';
import { AskStreamContextProvider } from './context/AskStreamContext';

function App() {
    return (
        <div id="aq-genai-root">
            <RecoilRoot>
                <AppContextProvider>
                    <ChatContextProvider>
                        <AskStreamContextProvider>
                            <ModalBox />
                            <Home />
                        </AskStreamContextProvider>
                    </ChatContextProvider>
                </AppContextProvider>
            </RecoilRoot>
        </div>
    );
}

export default App;
